import {executeAppToolCall} from "./handlers/appToolCallHandler/appToolCallHandler.ts";
import {executeWebsocketToolCall} from "./handlers/websocketToolCallHandler/websocketToolCallHandler.ts";
import {executeServerToolCall} from "./handlers/serverToolCallHandler/serverToolCallHandlers.ts";
import {validateToolCall} from "./utils/finishedToolCallValidator/validateToolCall.ts";
import {addToolMessage} from "./utils/utils.ts";
import {isMobileApp} from "../../../../../misc/envNameUtils.ts";
import {truncateToolMessagesByFilePath} from "../../../../contextManagement/messageTrucater.ts";
import {getToolAvailability} from "./utils/toolAvailability.ts";


export const executeToolCall = async (finishedToolCall: any, setMessages: any, messagesRef: any, currentMessageRef: any, messagesSequenceRef: any, updateElementInProgress: any, settingsObjRef: any, userObjRef: any, environmentObjRef: any, dynamicStateObjRef: any, llmRequestRefs: any, websocketRef: any) => {
    const availabilityResult = getToolAvailability(finishedToolCall.name, settingsObjRef, environmentObjRef);
    if (!availabilityResult.canUse) {
        addToolMessage(finishedToolCall, {errorMessage: availabilityResult.errorMessage}, llmRequestRefs, currentMessageRef, messagesSequenceRef, setMessages, messagesRef);
        updateElementInProgress(finishedToolCall.id, 'delete');
        return;
    }

    const validationResult = validateToolCall(finishedToolCall);

    if (!validationResult.isValid) {
        const errorMessages = validationResult.errors.map(error => error.message);
        finishedToolCall.name = "validationError";
        const results = {
            errorMessage: `Validation failed:\n${errorMessages.join('\n')}`
        };
        addToolMessage(finishedToolCall, results, llmRequestRefs, currentMessageRef, messagesSequenceRef, setMessages, messagesRef);
        updateElementInProgress(finishedToolCall.id, 'delete');
        return;
    }

    const needsServer = new Set(['searchCodebase', 'generateImages', 'alterImage', 'searchInternet']);
    const needsAuth = new Set(['searchCodebase']);
    const needsResponseFromApp = new Set(['openFile', 'createFile', 'editFile', 'runTerminalCommand', 'deleteFile', 'moveFile', 'searchCodebase', 'grepCodebase', 'viewDirectory', 'reviewChanges']);
    const needsWs = new Set(['gatherContext', 'deepResearch', 'createPdf', 'createDocx']);

    if (needsServer.has(finishedToolCall.name)) {
        // Extra metadata for search codebase, which the AI is unaware of
        if (finishedToolCall.name === "searchCodebase") {
            finishedToolCall.args.projectName = environmentObjRef.current.projectName;
        } else if (finishedToolCall.name === "searchInternet") {
            if (isMobileApp(environmentObjRef.current.environment)) finishedToolCall.args.type = "fast";
            else finishedToolCall.args.type = "balanced";

            // Track existing URLs to filter duplicates
            finishedToolCall.args.existingUrls = Array.from(llmRequestRefs.current.additionalContext.urlsAlreadySeen);
        }

        const results: any = await executeServerToolCall(finishedToolCall, settingsObjRef, userObjRef, needsAuth.has(finishedToolCall.name));

        if (needsResponseFromApp.has(finishedToolCall.name)) {
            // searchCodebase Also needs to pull updated file states from the IDE
            llmRequestRefs.current.additionalContext.serverResponseResults = results;
            executeAppToolCall(finishedToolCall, environmentObjRef, llmRequestRefs, dynamicStateObjRef, settingsObjRef);
        } else {
            // No need to execute anything. Context is already there, so just add it and continue
            addToolMessage(finishedToolCall, results, llmRequestRefs, currentMessageRef, messagesSequenceRef, setMessages, messagesRef);
            updateElementInProgress(finishedToolCall.id, 'delete');
        }
    }
    else if (needsWs.has(finishedToolCall.name)) {
        llmRequestRefs.current.wsFinishedToolCall = finishedToolCall;
        executeWebsocketToolCall(websocketRef, finishedToolCall, messagesSequenceRef, messagesRef, environmentObjRef, settingsObjRef, userObjRef, dynamicStateObjRef);
    }
    else if (needsResponseFromApp.has(finishedToolCall.name)) {
        // For openFile, truncate previous tool calls that showed the same file
        if (finishedToolCall.name === "openFile") {
            const requestedPath = finishedToolCall.args.filePath;
            truncateToolMessagesByFilePath(llmRequestRefs.current.toolMessages, requestedPath);
        }

        executeAppToolCall(finishedToolCall, environmentObjRef, llmRequestRefs, dynamicStateObjRef, settingsObjRef);
    }
    else {
        // No need to execute anything. Context is already there, so just add it and continue
        addToolMessage(finishedToolCall, {}, llmRequestRefs, currentMessageRef, messagesSequenceRef, setMessages, messagesRef);
        updateElementInProgress(finishedToolCall.id, 'delete');
    }
}
